import Guest from "@/Layouts/Guest";
import "./ValidateCode.scss";
import i18n from "i18next";
import axios from "axios";
import { useState } from "react";
import ValidationErrors from "@/Components/ValidationErrors";
import AmplifySpinner from "@/Components/AmplifySpinner";

const ValidateCode = () => {
    const validationCodeErrors = {
        incorrectCode: i18n.t(
            "onboard-user.validation-code-errors.incorrect-code"
        ),
        unknown: i18n.t("onboard-user.validation-code-errors.unknown"),
    };
    const userEmail = new URLSearchParams(window.location.search).get("email");

    const [isLoading, setIsLoading] = useState(false);
    const [validationCode, setValidationCode] = useState("");
    const [validationCodeError, setValidationCodeError] = useState(undefined);

    function obfuscateEmail(email) {
        return email.replace(/(^.{2})(.*?)(\@)(.{1,5})(.*$)/, "$1***$3*****$5");
    }

    function submitValidationCode(e) {
        const code = validationCode;

        setValidationCode("");
        setValidationCodeError(undefined);
        setIsLoading(true);

        axios
            .post("/ecomm/api/bff/validate-code", { code })
            .then(() => {
                window.location.href = "/organization/set-password";
            })
            .catch((e) => {
                switch (e.response.status) {
                    case 400:
                        setValidationCodeError(
                            validationCodeErrors.incorrectCode
                        );
                        break;
                    default:
                        setValidationCodeError(validationCodeErrors.unknown);
                }
            })
            .finally(() => {
                setIsLoading(false);
            });
    }

    return (
        <Guest>
            {isLoading && <AmplifySpinner />}

            <div className="onboarding-abstract-artwork">
                <svg
                    viewBox="0 0 661 761"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M142.758 319.961C142.758 319.961 124.407 353.032 122.518 365.689C99.4303 520.411 206.045 664.624 360.562 687.681C362.33 687.945 364.393 688.252 364.393 688.252C374.624 689.679 384.138 682.451 385.482 672.093C386.91 661.849 379.695 652.326 369.352 650.984L366.012 650.486C231.927 630.477 139.516 505.478 159.551 371.215C161.626 357.309 161.384 328.178 161.384 328.178C159.551 313.387 154.262 307.361 142.758 319.961Z"
                        fill="#FF600A"
                    />
                    <path
                        d="M94.522 361.511C119.914 191.346 278.423 73.9251 448.363 99.2835C493.844 106.07 535.386 122.425 571.546 145.92L597.125 106.399C555.453 79.4673 507.648 60.6697 455.389 52.8716C259.811 23.6874 77.3798 158.755 48.1569 354.593C46.6598 364.625 45.6685 374.633 44.9866 384.587L91.7423 387.541C92.3317 378.881 93.2303 370.167 94.5366 361.413L94.522 361.511Z"
                        fill="#A5D9F3"
                    />
                    <path
                        d="M101.021 484.852L55.4915 496.559C77.8425 583.654 132.502 659.482 207.759 708.318L233.323 668.895C167.957 626.462 120.438 560.649 101.006 484.95L101.021 484.852Z"
                        fill="#A5D9F3"
                    />
                    <path
                        d="M215.15 379.511C217.254 365.412 225.779 339.134 225.779 339.134L199.444 329.273C199.444 329.273 189.751 359.274 187.35 375.363C177.693 440.084 197.633 502.285 236.933 548.47L258.444 530.162C224.175 489.956 206.838 435.887 215.248 379.526L215.15 379.511Z"
                        fill="#F4BE45"
                    />
                    <path
                        d="M632.214 242.05C632.214 242.05 631.948 241.81 631.879 241.598C588.873 181.889 522.681 138.93 444.194 127.218C289.579 104.146 145.606 210.966 122.518 365.689C99.4302 520.411 206.044 664.624 360.562 687.681C362.33 687.945 364.393 688.253 364.393 688.253C374.624 689.679 384.137 682.451 385.482 672.094C386.91 661.849 379.695 652.326 369.352 650.984L366.012 650.486C231.926 630.477 139.516 505.478 159.551 371.215C179.586 236.952 304.463 144.376 438.548 164.384C507.31 174.645 565.121 212.532 602.357 265.146C608.589 272.511 619.605 274.055 627.705 268.225C636.144 262.144 637.989 250.454 632.017 242.021L632.214 242.05Z"
                        fill="#FF600A"
                    />
                    <path
                        d="M94.5219 361.511C119.914 191.346 278.423 73.9251 448.363 99.2835C493.844 106.07 535.386 122.425 571.546 145.92L597.125 106.399C555.453 79.4673 507.648 60.6697 455.389 52.8716C259.811 23.6874 77.3798 158.755 48.1569 354.593C46.6598 364.625 45.6685 374.633 44.9866 384.587L91.7423 387.541C92.3316 378.881 93.2303 370.167 94.5366 361.413L94.5219 361.511Z"
                        fill="#A5D9F3"
                    />
                    <path
                        d="M101.021 484.851L55.4914 496.559C77.8424 583.654 132.502 659.481 207.759 708.317L233.323 668.895C167.957 626.461 120.438 560.649 101.006 484.95L101.021 484.851Z"
                        fill="#A5D9F3"
                    />
                    <path
                        d="M215.15 379.511C230.59 276.035 326.916 204.538 430.255 219.958C434.872 220.647 439.361 221.518 443.836 222.487L448.004 194.553C443.53 193.583 438.942 192.698 434.424 192.023C315.76 174.316 205.095 256.444 187.35 375.363C177.693 440.084 197.633 502.285 236.933 548.47L258.443 530.162C224.175 489.956 206.838 435.887 215.248 379.526L215.15 379.511Z"
                        fill="#F4BE45"
                    />
                </svg>
            </div>

            <div className="login validate-code" style={{ maxWidth: "850px" }}>
                <div className="pb-4">
                    <img
                        data-testid="product_log-img"
                        src="/images/amplify-dashboard-logo.svg"
                        alt="product logo"
                    />
                </div>

                <div className="title pb-2">
                    Hold tight! Activating your account.
                </div>

                <div className="narrow-content">
                    <p className="pb-2">
                        🎉 We’re thrilled to have you on board!
                    </p>

                    <div className="pb-4">
                        <img
                            src="/images/onboarding-video-temp-thumb.png"
                            className="main-image"
                        />
                    </div>

                    <p className="pb-2">
                        Please enter the verification code we've sent to:
                        <b> {obfuscateEmail(userEmail)}</b> to verify your
                        identity.
                    </p>

                    <div className="p-0 pb-3">
                        {validationCodeError && (
                            <ValidationErrors
                                errors={{
                                    error: validationCodeError,
                                    custom: true,
                                }}
                            />
                        )}

                        <input
                            className="form-control-bootstrap"
                            id="validation_code"
                            type="text"
                            autoFocus={false}
                            value={validationCode}
                            onChange={(e) => {
                                setValidationCode(e.target.value);
                            }}
                            data-qa="input-enter-verification-code"
                            placeholder={i18n.t(
                                "onboard-user.validation-code-input-label"
                            )}
                        />
                    </div>

                    <button
                        className="btn btn-primary text-light w-100"
                        style={{ color: "white !important" }}
                        disabled={!Boolean(validationCode)}
                        onClick={submitValidationCode}
                    >
                        Continue
                    </button>
                </div>
            </div>
        </Guest>
    );
};

ValidateCode.layout = (page) => page;

export default ValidateCode;
